var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white mb-3" },
    _vm._l(_vm.tabs, function (tab) {
      return _c(
        "brb-btn",
        {
          key: `brb-tab-${tab.id}`,
          staticClass: "h-100 rounded-0 text-dark py-2",
          class: {
            activeTab: _vm.value === tab.id,
            "border-0 bg-transparent": _vm.value !== tab.id,
          },
          style: `width: ${100 / _vm.tabs.length}%;`,
          attrs: { size: "sm" },
          on: {
            click: function ($event) {
              return _vm.changeActiveTab(tab.id)
            },
          },
        },
        [_vm._v(" " + _vm._s(tab.title) + " ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }